import React from "react";
import styles from "./DiscordErrorBanner.module.scss";

export interface DiscordErrorBannerProps {
  severity: "error" | "warning";
  code: string;
  message: string;
  affectedUsers?: { userId: string; username: string }[];
  action?: {
    label: string;
    onClick: () => void;
  };
  onDismiss: () => void;
}

const DiscordErrorBanner: React.FC<DiscordErrorBannerProps> = ({
  severity,
  message,
  affectedUsers,
  action,
  onDismiss,
}) => {
  return (
    <div
      className={`${styles.banner} ${styles[severity]}`}
      role="alert"
      aria-live="polite"
    >
      <div className={styles.iconWrapper}>
        {severity === "error" ? (
          <svg
            className={styles.icon}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
              clipRule="evenodd"
            />
          </svg>
        ) : (
          <svg
            className={styles.icon}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </div>

      <div className={styles.content}>
        <p className={styles.message}>{message}</p>
        {affectedUsers && affectedUsers.length > 0 && (
          <ul className={styles.userList}>
            {affectedUsers.map((u) => (
              <li key={u.userId}>{u.username}</li>
            ))}
          </ul>
        )}
      </div>

      <div className={styles.actions}>
        {action && (
          <button
            type="button"
            className={styles.actionButton}
            onClick={action.onClick}
          >
            {action.label}
          </button>
        )}
        <button
          type="button"
          className={styles.dismissButton}
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default DiscordErrorBanner;
